import styled from 'styled-components';
import { LineBordered } from 'app/components';
import { textTransform } from 'utils';

export const CheckboxRow = styled(LineBordered)`
  label {
    .link {
      text-transform: none;
    }
  }
`;

export const GiftCardSection = styled.div.attrs({
  className: 'checkout-giftcard'
})`
  .checkout-giftcard__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;

    h3 {
      font-weight: 390;
      font-size: 18px;
      line-height: 24px;
    }
  }
  .step-checkout__description {
    margin-top: 50px;  
  }
  .step-checkout__description span:last-child a{
    color:red;
    text-decoration:underline;
  }
  .checkout-giftcard__giftcards_title {
    font-weight: 390;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 20px;
  }
  .checkout-giftcard__giftcard_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
    flex-wrap: wrap;
    row-gap: 16px;

    &:first-child {
      margin-top: 0;
    }
    .checkout-giftcard__barcode_number {
      padding: 9px 23px 7px;
      border: 1px solid rgba(255, 255, 255, 0.403108);
      border-radius: 20px;
      margin-right: 9px;
      width: 288px;
      height: 40px;
      & > h3 {
        font-weight: 390;
        font-size: 16px;
        line-height: 24px;
      }
    }
    .checkout-giftcard__price {
      display: flex;
      align-items: center;

      h3 {
        font-weight: 450;
        font-size: 18px;
        line-height: 24px;
        margin-right: 32px;
      }
      .checkout-giftcard__price_remove_btn {
        background: ${({ theme }) => theme.color.grey};
        color: ${({ theme }) => theme.color.white};
        border: none;
        height: 36px;
        /* width: 234px; */
        width: 238px;
        &:hover {
          background: rgba(102, 102, 102, 0.5);
          box-shadow: 0px 3px 16px rgb(88 85 85 / 50%);
        }
      }

      @media only screen and (max-width: 600px){
        .checkout-giftcard__price_remove_btn {
          display: none;
          }
        }
      }
    }
  /* } */
  .checkout-giftcard__add_new {
    display: flex;
    justify-content: space-between;
    margin: 12px 0 26px;
    align-items: center;
    flex-wrap: wrap;

    .checkout-giftcard__add_new_input {
      width: 288px;
    }

    .checkout-giftcard__add_new_btn {
        height: 36px;
        width: 234px;
        margin-top: 28px;
        z-index: 2;
      }

      @media only screen and (max-width: 600px){
        .checkout-giftcard__add_new_btn {
          display: none;
        }
      }

      @media only screen and (max-width: 352px){
        .checkout-giftcard__add_new_input {
          width: 272px;
         }
      }
    }
  /* } */
`;

export const BonusCardAttention = styled.div.attrs({
  className: 'attention-bonuscard'
})`
  .attention-bonuscard__content {
    margin-top: 56px;

    h2 {
      font-weight: 450;
      font-size: 18px;
      line-height: 24px;
      text-transform: ${textTransform};
    }
    h3 {
      font-weight: 390;
      font-size: 16px;
      line-height: 24px;
      margin-top: 8px;
    }
  }
  .attention-bonuscard__btn {
    margin-top: 56px;
    width: 200px;
  }
`;

export const IconButton = styled.button.attrs({
  type: 'button'
})`
  vertical-align: middle;
  width: 24px;
  height: 24px;
  border-radius: 50%;

  & > svg {
    width: 100%;
    height: 100%;
    fill: ${({ theme }) => theme.color.rgbaWhite('.2')};
    transition: fill 0.2s ease-out, box-shadow 0.2s ease-out;
  }

  &:hover {
    & > svg {
      fill: ${({ theme }) => theme.color.accentDark};
    }
  }

  &:disabled > svg {
    fill: ${({ theme }) => theme.color.rgbaWhite('.2')};
  }
  @media only screen and (min-width: 600px){
    display: none;
  }
`;

export const IconButtonPlus = styled.button.attrs({
  type: 'button'
})`
  vertical-align: middle;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-top: 15px;
  
  & > svg {
    width: 100%;
    height: 100%;
    fill: ${({ theme }) => theme.color.accent};
    transition: fill 0.2s ease-out, box-shadow 0.2s ease-out;
    /* margin-top: 10px; */
  }

  &:hover {
    & > svg {
      fill: ${({ theme }) => theme.color.accentDark};
    }
  }

  @media only screen and (min-width: 600px){
    display: none;
  }
`;


export default CheckboxRow;
